import { render, staticRenderFns } from "./AppContainerRoot.vue?vue&type=template&id=55b82318"
import script from "./AppContainerRoot.vue?vue&type=script&lang=ts"
export * from "./AppContainerRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports